import React from "react";
import { Grid } from "@material-ui/core";
import { useNavigate } from "react-router";

import {
  New,
  NewDescription,
  NewImage,
  NewTheme,
  NewTitle,
} from "components/new";
import { INewsPagedRespomse } from "models/response/news-paged-response";
import { PaginationResponse } from "models/pagination-response";

type NewsGridProps = {
  currentItems: PaginationResponse<INewsPagedRespomse>;
};

export const NewsGrid: React.FC<NewsGridProps> = ({ currentItems }) => {
  const navigate = useNavigate();
  return (
    <Grid container spacing={4}>
   {
Array.isArray(currentItems.items) && currentItems.items.length > 0 ? (
        currentItems.items.map((item: INewsPagedRespomse) => (
          <Grid item xs={12} md={6} lg={3} key={item.id}>
          <New onClick={() => navigate(`/noticias/${item.id}`)}>
            <NewImage src={item.imageUrl} alt={item.title} />
            <NewTheme>{item.category}</NewTheme>
            <NewTitle>{item.title}</NewTitle>
            <NewDescription>{item.subtitle}</NewDescription>
          </New>
        </Grid>
        ))
      ) : (
        <p></p>
      )}

    </Grid>
  );
};
